import styled from 'styled-components';

export const StyledAvatar = styled.img`
  object-fit: cover;
  width: 52px;
  height: 52px;
`;
